
import { StringHelper } from "../../../../../utilities/contracts/string-helper";

export class OrganizationPendCode {
  pendCodesCsv: string;
  inActivePendCodesCsv: string;

  constructor(options: {
    pendCodesCsv: string;
    inActivePendCodesCsv: string;

  }) {
    this.pendCodesCsv = StringHelper.clean(options.pendCodesCsv);
    this.inActivePendCodesCsv = StringHelper.clean(options.inActivePendCodesCsv);

  }

}

